<div class="review-import-method">
  <div class="import-options">
    <div class="import-option" [class.selected]="isCsvSelected" (click)="selectImportMethod('csv')">
      <div class="radio-indicator" [class.checked]="isCsvSelected"></div>
      <div class="import-option-content">
        <span class="import-option-title">CSV Upload</span>
        <span class="import-option-subtitle">Upload a CSV file with your reviews</span>
      </div>
    </div>

    <div class="import-option" [class.selected]="isIntegrationSelected" (click)="selectImportMethod('integration')">
      <div class="radio-indicator" [class.checked]="isIntegrationSelected"></div>
      <div class="import-option-content">
        <span class="import-option-title">Direct Integration</span>
        <span class="import-option-subtitle">Connect via API to automatically sync reviews</span>
      </div>
    </div>
  </div>

  @if (isIntegrationSelected) {
    <div class="choose-platform-section">
      <div class="platform-header">
        <div class="platform-header-text">
          <span class="platform-title">Choose Platform</span>
          <span class="platform-subtitle">Select from your connected review platforms</span>
        </div>
        <a class="manage-integrations-link" (click)="navigateToIntegrations()">Manage Integrations</a>
      </div>
      <div class="platform-tiles">
        @for (platform of reviewPlatforms; track platform.name) {
          <div
            class="platform-tile"
            [class.selected]="selectedPlatform === platform.name"
            [class.disabled]="!isPlatformSelectable(platform)"
            (click)="selectPlatform(platform)">
            @if (isIntegrationConnected(platform.name)) {
              <div class="connected-badge">
                <pdq-icon icon="check" size="small"></pdq-icon>
              </div>
            }
            @if (!isPlatformAvailable(platform)) {
              <pdq-tag value="Soon" size="small" variant="info" mode="rounded" class="coming-soon-badge"></pdq-tag>
            }
            <div class="platform-content">
              <img
                class="platform-logo"
                [src]="'/assets/images/integrations/' + platform.name + '_mini.svg'"
                [alt]="platform.displayName" />
              <span class="platform-name">{{ platform.displayName }}</span>
            </div>
          </div>
        }
      </div>
      @if (hasNoIntegrationSelectedError) {
        <span class="validation-error">At least one integration must be connected and selected</span>
      }
    </div>
  }
</div>
